import React from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { BulkEditionMenu } from 'common/components';

const BulkMenu = ({
    filterData,
    handleClickBulkItems,
    selectedBulkOption,
    selectionModel,
    setSelectedBulkOption,
    setSelectionModel,
}) => {
    const { t } = useTranslation();
    const isArchivedList = filterData?.status === 'archived';

    const callback = () => {
        setSelectedBulkOption('');
        setSelectionModel([]);
    };
    const prefix = t('Project', {
        count: selectionModel.length,
    }).toLocaleLowerCase();

    if (isEmpty(selectionModel)) return null;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
            <BulkEditionMenu
                items={[
                    {
                        label: t('Archive'),
                        handleClick: () =>
                            handleClickBulkItems(
                                selectionModel,
                                'archived',
                                filterData,
                                callback,
                            ),
                        visible: !isArchivedList,
                    },
                    {
                        label: t('Unarchive'),
                        handleClick: () =>
                            handleClickBulkItems(
                                selectionModel,
                                'active',
                                filterData,
                                callback,
                            ),
                        visible: isArchivedList,
                    },
                    {
                        label: t('Delete'),
                        handleClick: () =>
                            handleClickBulkItems(
                                selectionModel,
                                'deleted',
                                filterData,
                                callback,
                            ),
                        visible: isArchivedList,
                    },
                ]}
                prefix={prefix}
                selectedBulkOption={selectedBulkOption}
                selectionModel={selectionModel}
                setSelectedBulkOption={setSelectedBulkOption}
                setSelectionModel={setSelectionModel}
            />
        </Box>
    );
};

BulkMenu.propTypes = {
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    selectedBulkOption: PropTypes.string,
    selectionModel: PropTypes.array,
    setSelectedBulkOption: PropTypes.func,
    setSelectionModel: PropTypes.func,
};

export default BulkMenu;
